import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[username]/page.tsx");
